import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { RhybuddService } from 'src/app/craidd/gwasanaethau/system/rhybudd.service';
import { Rhybudd, MathRhybudd } from 'src/app/craidd/modelau/rhybudd';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-rhybudd',
    templateUrl: './rhybudd.component.html',
    styleUrls: ['./rhybudd.component.scss'],
    imports: [FaIconComponent, TranslatePipe]
})
export class RhybuddComponent implements OnInit, OnDestroy {

    @Input() id: string;

    rhybuddion: Rhybudd[] = [];
    subscription: Subscription;

    constructor(private rhybuddService: RhybuddService) { }

    ngOnInit() {
        this.subscription = this.rhybuddService.onAlert(this.id)
            .subscribe(rhybudd => {
                if (!rhybudd.neges) {
                    this.rhybuddion = [];
                    return;
                }

                this.rhybuddion.push(rhybudd);
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    dileuRhybudd(rhybudd: Rhybudd) {
        this.rhybuddion = this.rhybuddion.filter(x => x !== rhybudd);
    }

    cssClass(rhybudd: Rhybudd) {
        if (!rhybudd) {
            return;
        }

        switch (rhybudd.math) {
            case MathRhybudd.Llwyddiant:
                return 'neges-llwyddiant';
            case MathRhybudd.Gwall:
                return 'neges-gwall';
            case MathRhybudd.Gwybodaeth:
                return 'neges-gwybodaeth';
            case MathRhybudd.Rhybudd:
                return 'neges-rhybudd';
        }
    }
}
